import type { ReactElement } from 'react';
import type { Mode } from 'light-component';

export interface GridDesignerProps extends GridDesignerData {
  mode?: Mode;

  /**
   * 表格类型，input: 用于接收输入的表格，setting: 用于设置单元格的表格
   */
  type: 'input' | 'setting';

  /**
   * 单元格设置用的弹窗
   */
  settings?: ReactElement;
  cellModal?: ReactElement;
  className?: string;
  onChange?: (props: GridDesignerData) => void;
}

export interface GridDesignerData<T extends CellSetting = CellSetting> {
  value?: CellValue[][];
  option?: Partial<T>[][];

  /**
   * 表格的总行数，包括标题行，默认 1
   */
  gridRow?: number;

  /**
   * 表格的总列数，包括标题列，默认 1
   */
  gridCol?: number;

  /**
   * 表格的行标题数，默认 0
   */
  gridRowTitle?: number;

  /**
   * 表格的列标题数，默认 0
   */
  gridColTitle?: number;
}

/**
 * Input 模式下，单元格输入值
 */
export type CellValue = string | number;

export enum CellType {
  NUMBER = 'number',
  TEXT = 'text',
}

export enum CellEnable {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

export enum CellOptional {
  YES = 'yes',
  NO = 'no',
}

export enum CellEmpty {
  NO = 'no',
  YES = 'yes',
}

/**
 * 单元格设置信息
 */
export interface CellSetting {
  title?: CellValue;
  /**
   * 列宽 '150px'
   */
  width?: string;
  // 哪行哪列 A1 | A2 | B1 | B2
  field: string;
  placeholder?: string;
  // 类型
  type?: CellType;
  // 公式
  fx?: string;
  // 取值条件
  condition?: { min: string; max: string; value: string }[];
  // 编辑
  enable?: CellEnable;
  // 选填
  optional?: CellOptional;
  // 置空
  empty?: CellEmpty;
}

/**
 * 表格单元格位置
 */
export interface CellPos {
  col: number;
  row: number;
}

export interface GridDesignerModalRef<T extends CellSetting = CellSetting> {
  show: (value: T, pos: CellPos) => Promise<T>;
}

export type ChangeAction = 'change' | 'change-all';
export type SettingAction = 'setting-col' | 'setting-row' | 'setting-cell';
export type RowAction = 'add-prev-row' | 'add-next-row' | 'remove-row';
export type ColAction = 'add-prev-col' | 'add-next-col' | 'remove-col';
export type Action = SettingAction | RowAction | ColAction | ChangeAction;

export interface CustomInputData {
  [cellName: string]: string | number;
}
